export const noNegativeOptions = {
  format: { neg: "%s%v" },
};
